import { useState } from "react";

import Text from "ab-text";
import Button from "ab-button";
import ParagraphText from "ab-paragraph-text";

const Menu = ({ title, curso = [], precio, notas, addicional, legal }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="item">
      <div className="detail">
        <div>
          <Text element="h2">{title}</Text>
        </div>

        <Button
          type={isOpen ? "menos" : "mas"}
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>
      <div className={`carta${isOpen ? " show" : ""}`}>
        {curso?.map((itm) => (
          <>
            {itm.nombre ? (
              <Text element="span" className="title border">
                {itm.nombre}
              </Text>
            ) : null}
            {itm.platos?.map((plate) => (
              <ParagraphText content={` - ${plate.nombre}`} singleColumn className={'flex-start'} />

              // <Text>{` - ${plate.nombre}`}</Text>
            ))}
          </>
        ))}
        <Text element="span" className="title">
          {precio}
        </Text>
        <Text element="span" className="title">
          {addicional}
        </Text>
        {notas?.map((itm) => (
          <Text element="span" className="title light">
            {itm.nota}
          </Text>
        ))}

        <Text className="legal">{legal}</Text>
      </div>
    </div>
  );
};

export default Menu;
